module.exports = __webpack_public_path__ + "img/ilk.feb3634d.svg";